import { useEffect, useState } from "react";

const pad = (n) => String(n).padStart(2, "0");

const Countdown = ({ target, status, compact = false }) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const diff = Math.max(0, new Date(target).getTime() - now);
  const reached = diff <= 0;
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const minutes = Math.floor((diff % 3600000) / 60000);
  const seconds = Math.floor((diff % 60000) / 1000);

  const cells = [
    { value: reached ? "00" : String(days), label: "Days" },
    { value: pad(hours), label: "Hours" },
    { value: pad(minutes), label: "Minutes" },
    { value: pad(seconds), label: "Seconds" },
  ];

  return (
    <div data-testid={compact ? "countdown-compact" : "countdown"}>
      <div className={`grid grid-cols-4 ${compact ? "gap-2 sm:gap-3" : "gap-3 sm:gap-5"}`}>
        {cells.map((c) => (
          <div
            key={c.label}
            data-testid={`countdown-${c.label.toLowerCase()}`}
            className={`card-surface rounded-lg text-center ${compact ? "px-2 py-3" : "px-3 py-5 sm:px-6 sm:py-7"}`}
          >
            <div className={`gold-number font-semibold ${compact ? "text-xl sm:text-2xl" : "text-3xl sm:text-5xl"}`}>
              {c.value}
            </div>
            <div className="mt-2 font-mono text-[10px] sm:text-xs tracking-[0.25em] uppercase text-slate">{c.label}</div>
          </div>
        ))}
      </div>
      {reached && (
        <p className="mt-4 text-center font-mono text-xs tracking-[0.2em] uppercase text-slate" data-testid="countdown-reached-note">
          {status === "live"
            ? "The presale window is open."
            : "The target date has been reached. Official presale status will be confirmed by the Jovino Coin Foundation."}
        </p>
      )}
    </div>
  );
};

export default Countdown;
